import { Component, DOCUMENT, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { AppService } from './core/services/app.service';


@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ButtonModule, TranslateModule, ConfirmDialogModule, ProgressSpinnerModule, ToastModule],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  providers:[]
})
export class App {
  protected readonly title = signal('admin');
  public appService = inject(AppService);
  document = inject(DOCUMENT);

  constructor(){
    this.appService.changeLanguage(this.appService.savedLanguage,{reload:false});
    const element = this.document.querySelector('html');
    element?.classList.remove('dark');
    element?.classList.remove('_-app-dark');
    element?.classList.remove('app-dark');
    // element?.getElementsByClassName('dark');    

  }
}
